import { render, staticRenderFns } from "./WhiteBtn.vue?vue&type=template&id=27d1a620&"
import script from "./WhiteBtn.vue?vue&type=script&lang=js&"
export * from "./WhiteBtn.vue?vue&type=script&lang=js&"
import style0 from "./WhiteBtn.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports